import { Injectable } from "@angular/core";
import { ConfigManagerService } from "./config-manager.service";
import { TipoRecaptcha } from "../enums/recaptchaEnum";

@Injectable({
  providedIn: "root",
})
export class RecaptchaService {
  private configuracoes: any;
  private turnstileCarregado = false;
  chaveGoogle = "";
  chaveCloudflare = "";

  constructor(private servicoConfiguracao: ConfigManagerService) {}

  async iniciar(): Promise<void> {
    const configStr = sessionStorage.getItem("configCRC");

    if (!configStr) {
      await this.servicoConfiguracao.Init();
    }

    this.configuracoes = JSON.parse(sessionStorage.getItem("configCRC") ?? "{}");
    this.chaveGoogle = this.configuracoes?.RECAPTCHA_TOKEN_GOOGLE;
    this.chaveCloudflare = this.configuracoes?.RECAPTCHA_TOKEN_CLOUDFLARE_DESAFIO;
  }

  identificarTipoRecaptcha(): TipoRecaptcha {
    const cfg = JSON.parse(sessionStorage.getItem("configCRC") ?? "{}");
    if (!cfg?.VALIDAR_RECAPTCHA_CLOUDFLARE && !cfg?.VALIDAR_RECAPTCHA_GOOGLE) {
      return TipoRecaptcha.Desabilitado;
    }

    if (cfg?.VALIDAR_RECAPTCHA_CLOUDFLARE) return TipoRecaptcha.Cloudflare;
    if (cfg?.VALIDAR_RECAPTCHA_GOOGLE) return TipoRecaptcha.Google;

    return TipoRecaptcha.Nenhum;
  }

  identificarRecaptchaDesafio(): TipoRecaptcha {
    if (!this.configuracoes?.VALIDAR_RECAPTCHA_CLOUDFLARE_DESAFIO && !this.configuracoes?.VALIDAR_RECAPTCHA_GOOGLE_DESAFIO) {
      return TipoRecaptcha.Desabilitado;
    }

    if (this.configuracoes?.VALIDAR_RECAPTCHA_CLOUDFLARE_DESAFIO) return TipoRecaptcha.Cloudflare;
    if (this.configuracoes?.VALIDAR_RECAPTCHA_GOOGLE_DESAFIO) return TipoRecaptcha.Google;

    return TipoRecaptcha.Nenhum;
  }

  async executarRecaptcha(acao: string = "default"): Promise<string> {
    await this.iniciar();
    const tipo = this.identificarTipoRecaptcha();

    if (tipo === TipoRecaptcha.Google) {
      await this.carregarScriptGoogle();
      return this.executarRecaptchaGoogle(acao);
    }

    if (tipo === TipoRecaptcha.Cloudflare) {
      await this.carregarScriptCloudflare();
      return this.executarRecaptchaCloudflare();
    }

    return "";
  }

  private async carregarScriptGoogle(): Promise<void> {
    if (document.getElementById("recaptcha-script")) return;

    const chave = this.configuracoes?.RECAPTCHA_TOKEN_GOOGLE_V3;
    const script = document.createElement("script");
    script.id = "recaptcha-script";
    script.src = `${this.configuracoes?.URL_RECAPTCHA_GOOGLE}?render=${chave}`;
    script.async = true;
    script.defer = true;

    return new Promise((resolve, reject) => {
      script.onload = () => resolve();
      script.onerror = () =>
        reject(new Error("Erro ao carregar o script do reCAPTCHA"));
      document.body.appendChild(script);
    });
  }

  private async carregarScriptCloudflare(): Promise<void> {
    if (this.turnstileCarregado || document.getElementById("turnstile-script")) {
      this.turnstileCarregado = true;
      return;
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.id = "turnstile-script";
      script.src = this.configuracoes?.URL_TURNSTILE_CLOUDFLARE;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        this.turnstileCarregado = true;
        resolve();
      };
      script.onerror = () =>
        reject(new Error("Erro ao carregar o script do Turnstile"));
      document.body.appendChild(script);
    });
  }

  private async executarRecaptchaGoogle(acao: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const chave = this.configuracoes?.RECAPTCHA_TOKEN_GOOGLE_V3 ?? "";

      if (typeof grecaptcha === "undefined") {
        return reject(new Error("grecaptcha não está disponível"));
      }

      grecaptcha.ready(() => {
        (grecaptcha.execute(chave, { action: acao }) as Promise<string>)
          .then((token) => resolve(token))
          .catch((erro) => reject(erro));
      });
    });
  }

  private async executarRecaptchaCloudflare(): Promise<string> {
    return new Promise((resolve, reject) => {
      const chave = this.configuracoes?.RECAPTCHA_TOKEN_CLOUDFLARE ?? "";
      const idContainer = "cf-turnstile";
      const existente = document.getElementById(idContainer);
      if (existente) {
        existente.remove();
      }

      const div = document.createElement("div");
      div.id = idContainer;
      document.body.appendChild(div);

      if ((window as any)?.turnstile) {
        try {
          (window as any).turnstile.render(`#${idContainer}`, {
            sitekey: chave,
            callback: (token: string) => {
              resolve(token);
              const container = document.getElementById(idContainer);
              if (container) container.remove();
            },
            "expired-callback": () => {
              reject(new Error("Token expirado"));
            },
            "error-callback": (erro: any) => {
              reject(erro);
            },
          });
        } catch (erro) {
          reject(new Error("Erro ao renderizar o Turnstile"));
        }
      } else {
        reject(new Error("Turnstile não está disponível"));
      }
    });
  }
}
